import { useMemo } from 'react'
import { useDataTableContext } from './DataTableContext'

/**
 * please ensure this hook under DataTableContext
 * @param groupRowkey
 * @returns
 */
function useCollapse(groupRowkey: string) {
    const { openCollapses } = useDataTableContext()
    const openCollapse = useMemo(() => openCollapses.includes(groupRowkey), [
        openCollapses,
        groupRowkey,
    ])

    return {
        openCollapse,
    }
}
export default useCollapse
